import { render, staticRenderFns } from "./ShowRate.vue?vue&type=template&id=2e85bbf6&scoped=true&"
import script from "./ShowRate.vue?vue&type=script&lang=js&"
export * from "./ShowRate.vue?vue&type=script&lang=js&"
import style0 from "./ShowRate.vue?vue&type=style&index=0&id=2e85bbf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e85bbf6",
  null
  
)

export default component.exports